import React from 'react';
import './Footer.css';
 
import LogoUnicamp from '../../assets/images/logo_unesp-assis.png'
import LogoFapesp from '../../assets/images/fapesp.png'

import navIcon1 from '../../assets/images/youtube.svg'
import navIcon2 from '../../assets/images/twitter.svg'
import navIcon3 from '../../assets/images/instagram.svg'
import navIcon4 from '../../assets/images/face.svg'
function Footer() {
  return (



    <div className='footer-container'>
 

      <section class='social-media'>
     
      <div className='logos'>
      <img className="img-logo-fapesp" src={LogoFapesp} />
              <img className="img-logo-unicamp" src={LogoUnicamp} />
             
          </div>

        <div class='social-media-wrap'>
       
        <div class="col-sm-12 col-md-12 col-lg-12 text-center ">
        
       
          <small class='website-rights'>ESTE SITE NÃO EXPRESSA A OPINIÃO DA FAPESP. <br />

            <a href="/" className="hrefFooter">umahistoriadapeninsula.com.br - </a>

            <a href="/politicas-de-privacidade-e-termo-de-uso" className="hrefFooter">Políticas de Privacidade</a>
          </small>
         

         
          </div>
          <div className="div-social-icon">
          <div className="social-icon">
              <a href="https://www.youtube.com/channel/UCOqszOrTMrhmlUvWCKXiT0A"><img src={navIcon1} alt="" /></a>
              <a href="https://twitter.com/DaPeninsula"><img src={navIcon2} alt="" /></a>
              <a href="https://www.instagram.com/historiadapeninsula/"><img src={navIcon3} alt="" /></a>
              <a href="https://www.facebook.com/profile.php?id=61558268759636&name=xhp_nt__fb__action__open_user&_rdr"><img src={navIcon4} alt="" /></a>
            
            </div>
            </div>

          </div>
          
       
      </section>
    </div>
  );
}

export default Footer;
 
